import http from '../../utils/http'
import { getParamsFromQueryString } from '../../utils/url'
import { allowedAppIds, isStaging } from '../../utils/constants'

const { app_id: appId } = getParamsFromQueryString()

const base64Encode = (str) => {
  if (typeof globalThis !== 'undefined' && globalThis.btoa) {
    return globalThis.btoa(str)
  }
  return Buffer.from(str).toString('base64')
}

// Endpoints
const usersEndpoint = isStaging ? ('/users') : (allowedAppIds.includes(appId) ? '/email_confirmations' : '/users')
const signInEndpoint = '/users/auth'
const getMyDataEndpoint = '/users'
const logoutEndpoint = '/users/logout'

export const signIn = credentials => {
  return http.post(signInEndpoint, {
    login: credentials.login.trim().toLowerCase(),
    password: base64Encode(credentials.password),
    user_application_id: appId
  }).catch(error => error.response)
}

export const signUp = signupData => {
  return http
    .post(usersEndpoint, {
      ...signupData,
      name: signupData.name.trim(),
      email: signupData.email.trim(),
      password: signupData.password.trim(),
      user_application_id: appId
    })
    .then(res => res.data)
}

export const updateEmail = ({ user, email }) => {
  return http
    .put(`${usersEndpoint}/${user.id}`, {
      email
    })
    .then(res => res.data)
}

export const getMyData = () => {
  return http
    .get(getMyDataEndpoint)
    .then(res => res.data)
}

export const logout = () => {
  return http.post(logoutEndpoint)
}
